module.exports = __webpack_public_path__ + "img/icon-edit.dc604e7e.svg";